import React, {FC} from 'react';

import QuestionCheckbox from '../../components/QuestionCheckbox';
import {ESTATE_OPTIONS} from '../../constants';

const StepEstatePlanning: FC = () => (
  <QuestionCheckbox field="estatePlanning" options={ESTATE_OPTIONS} />
);

export default StepEstatePlanning;
